<script>
    import { format } from 'date-fns';

    export default {
        props: {
            order: {
                type: Object,
                required: true,
            },
            initialComment: {
                type: Object,
                required: false,
                default: null,
            },
        },
        data() {
            return {
                toggled: false,
                comment: null,
                body: null,
            };
        },
        computed: {
            commentExists() {
                return this.comment && this.comment.id;
            },
            updatedAt() {
                return format(
                    this.comment.updated_at,
                    'YYYY-MM-DD [  kl. ] HH:mm',
                );
            },
            orderCommentModalName() {
                return `show-order-comment-form-${this.order.id}`;
            },
            deleteCommentModalName() {
                return `delete-order-comment-${this.order.id}`;
            },
        },
        created() {
            if (this.initialComment) {
                this.comment = this.initialComment;
                this.body = this.initialComment.body;
            }
        },
        methods: {
            commentWasStored({ data }) {
                this.comment = data;
                this.$modal.hide(this.orderCommentModalName);
            },
            commentWasDeleted() {
                this.comment = null;
                this.body = null;
                this.$modal.hide(this.deleteCommentModalName);
            },
        },
    };
</script>
